import { useCartStore } from "../../../../hooks/stores/useCartStore";
import { Heading } from "../../../../components/common/typography";
import { BasketItemCard } from "./basket-item-card";
import { BasketOrderSummary } from "./basket-order-summary";
import { BasketBestDeals } from "./basket-best-deals";

interface BasketViewProps {
  onProceed: () => void;
}

export function BasketView({ onProceed }: BasketViewProps) {
  const { items, removeFromCart, updateQuantity } = useCartStore();

  return (
    <div className="flex w-full flex-col gap-6 px-8 py-6">
      <Heading variant="h2" tone="dark">Cart</Heading>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <div className="flex flex-col gap-3 lg:col-span-2">
          {items.map((item) => (
            <BasketItemCard
              key={item.product.id}
              product={item.product}
              quantity={item.quantity}
              warranty={item.warranty}
              onRemove={() => removeFromCart(item.product.id)}
              onUpdateQuantity={(qty) => updateQuantity(item.product.id, qty)}
            />
          ))}
          <BasketBestDeals />
        </div>

        <div className="lg:col-span-1">
          <BasketOrderSummary onProceed={onProceed} />
        </div>
      </div>
    </div>
  );
}
